export const numberingSystemNames: ReadonlyArray<string> = [
  'adlm',
  'ahom',
  'arab',
  'arabext',
  'armn',
  'armnlow',
  'bali',
  'beng',
  'bhks',
  'brah',
  'cakm',
  'cham',
  'cyrl',
  'deva',
  'diak',
  'ethi',
  'fullwide',
  'gara',
  'geor',
  'gong',
  'gonm',
  'grek',
  'greklow',
  'gujr',
  'gukh',
  'guru',
  'hanidays',
  'hanidec',
  'hans',
  'hansfin',
  'hant',
  'hantfin',
  'hebr',
  'hmng',
  'hmnp',
  'java',
  'jpan',
  'jpanfin',
  'jpanyear',
  'kali',
  'kawi',
  'khmr',
  'knda',
  'krai',
  'lana',
  'lanatham',
  'laoo',
  'latn',
  'lepc',
  'limb',
  'mathbold',
  'mathdbl',
  'mathmono',
  'mathsanb',
  'mathsans',
  'mlym',
  'modi',
  'mong',
  'mroo',
  'mtei',
  'mymr',
  'mymrepka',
  'mymrpao',
  'mymrshan',
  'mymrtlng',
  'nagm',
  'newa',
  'nkoo',
  'olck',
  'onao',
  'orya',
  'osma',
  'outlined',
  'rohg',
  'roman',
  'romanlow',
  'saur',
  'segment',
  'shrd',
  'sind',
  'sinh',
  'sora',
  'sund',
  'sunu',
  'takr',
  'talu',
  'taml',
  'tamldec',
  'telu',
  'thai',
  'tibt',
  'tirh',
  'tnsa',
  'tols',
  'vaii',
  'wara',
  'wcho',
]
